import React, {useEffect} from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function Toast ({type='info',message = '',hideProgressBar=false, progressClassName=null}){

    useEffect(()=>{

        if (message){
            toast[type](message)
        }

    },[type,message])

    return(

                    <ToastContainer
                                position="bottom-right"
                                theme={"colored"}
                                autoClose={5000}
                                hideProgressBar={hideProgressBar}
                                progressClassName={progressClassName}
                                newestOnTop={false}
                                closeOnClick
                                rtl
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover

                    />
    )
}